export const DEFAULT_COUNTER_ORDER_TYPES = [
    { id: "counter", labelKey: "counter.type.counter" },
    { id: "doordash", labelKey: "counter.type.doordash" },
    { id: "ubereats", labelKey: "counter.type.ubereats" },
];
//# sourceMappingURL=CounterOrderType.js.map